import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';

import animateScrollTo from 'animated-scroll-to';

import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

// import Glide from '@glidejs/glide/dist/glide.min.js';
import Glide, { Controls, Breakpoints, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'
import '@glidejs/glide/src/assets/sass/glide.core.scss';
import '@glidejs/glide/src/assets/sass/glide.theme.scss';

const moduleSelector = '.eiovisual-cover3';

var scrollTimer;

/**
 * Classe esempio
 */
class Module {

    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo mc cover3');
    }
    
    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            if($modules && $modules.length>0) {
                $modules.forEach(($module) => {
                    new ModuleFeature($module);
                });
            }
        });
    }
}

class ModuleFeature {

    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    /**
     * Metodo di debounce, usato per addEventListener
     * @param {type} func
     * @param {type} delay
     * @returns {Function}
     */
    debounce(func, delay) {
        let inDebounce
        
        return () => {
            const context = this
            const args = arguments
            clearTimeout(inDebounce)
            inDebounce = setTimeout(() => func.apply(context, args), delay)
        }
    }

    // _________________________________________________________________________

    /**
     * Inizializza le tasks di questo modulo
     * @returns {undefined}
     */
    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1() },0);
        setTimeout(() => { this.task2() },50);
        setTimeout(() => { this.task3() },100);
        setTimeout(() => { this.task4() },150);
        setTimeout(() => { this.task5() },200);
    }

    // _________________________________________________________________________

    /**
     * Inizializza il carousel Glide
     * @returns {undefined}
     */
    task1() {
        this.carousel_init();
    }

    // _________________________________________________________________________

    /**
     * Allo scroll switcha gli steps
     * @returns {undefined}
     */
    task2() {
        this.step = 1; // init
        var that = this;
        
        var $step1 = this.$module.querySelector('.step1');
        var $step2 = this.$module.querySelector('.step2.active'); // inizializza solo con step active
        var $substeps = this.$module.querySelectorAll('.substep');
        var $glide = this.$module.querySelector('.glide');
        var $navbarModels = document.querySelector('#navbar-models');
        var $logoMain = document.querySelector('#navbar-models-container .logo-main');
        var $logoAside = document.querySelector('#navbar-models-container .logo-aside');
        
        this.timeline = new TimelineMax();
        this.controller = new ScrollMagic.Controller();
        
        // _____________________________________________________________________

        // pin modulo
        var chunk1scene1 = new ScrollMagic.Scene({triggerElement: "#trigger1", duration: 1200, triggerHook: "onLeave"})
            .setPin(this.$module)
            .addTo(this.controller);
    
        // _____________________________________________________________________
        
        // step top
        var chunk1sceneTop = new ScrollMagic.Scene({triggerElement: "#trigger1"})
            .addTo(this.controller);
        
        // _____________________________________________________________________

        // step 1
        var chunk1scene2Tween = this.timeline
            .to($step1, 2, {transform:"translateX(-200px) translateY(-30px)", opacity: 0, ease: Power4.easeOut});
        
        var chunk1scene2 = new ScrollMagic.Scene({triggerElement: "#trigger1", triggerHook: "onLeave", duration: 450})
            .setTween(chunk1scene2Tween)
            .addTo(this.controller);
    
        // _____________________________________________________________________

        // step 2: substeps
        
        var chunk1scene3Tween = [] ;

        // nel tween inserisce i substep
        $substeps.forEach(($substep,i) => {
            chunk1scene3Tween[i] = this.timeline
                .to($substep, i, {transform: "translateY(0)", opacity: 1, ease: Power4.easeOut});
        });
        // ultimo substep è lo sfondo scuro
        chunk1scene3Tween[chunk1scene3Tween.length] = this.timeline.to($glide, 5, {opacity: 1, ease: Power4.easeOut});
        
        var chunk1scene3 = new ScrollMagic.Scene({triggerElement: "#trigger3", triggerHook: "onLeave", duration: 300})
            .setTween(chunk1scene3Tween)
            .addTo(this.controller);
    
        // _____

        // STEPS

        // se entra nei substeps, è sempre step 2
        chunk1scene3.on("enter", function (event) {
            that.step = 2;
        });
        
        chunk1scene3.on("leave", function (event) {
            // se rwd, lo step precedente dei substeps è 1
            if(event.scrollDirection == 'REVERSE') {
                that.step = 1;
            }
            // se esce fwd, allora è andato oltre i substeps, identificato come step 3 (oltre la fascia)
            if(event.scrollDirection == 'FORWARD') {
                that.step = 3;
            }
        });

        // _____
        
        // _____________________________________________________________________
        
        // step navbarModels
        $navbarModels.style.opacity = 0;
        $navbarModels.style.transform = "translateY(-100px)";
        
        var chunk1scene3Tween = this.timeline
            .to($navbarModels, 2, {transform:"translateY(0)", opacity: 1, ease: Power4.easeOut});
        
        var chunk1scene3 = new ScrollMagic.Scene({triggerElement: "#trigger1", triggerHook: "onLeave", duration: 200})
            .setTween(chunk1scene3Tween)
            .addTo(this.controller);
    
        // _____________________________________________________________________
        
        // step logo-main
        $logoMain.style.opacity = 0;
        $logoMain.style.transform = "translateY(-100px)";
        
        var chunk1scene4Tween = this.timeline
            .to($logoMain, 5, {transform:"translateY(0)", opacity: 1, ease: Power4.easeOut});
        
        var chunk1scene4 = new ScrollMagic.Scene({triggerElement: "#trigger1", triggerHook: "onLeave", duration: 200})
            .setTween(chunk1scene4Tween)
            .addTo(this.controller);
    
    
        // _____________________________________________________________________

        // step logo-aside
        $logoAside.style.opacity = 0;
        $logoAside.style.transform = "translateY(-100px)";
        
        var chunk1scene5Tween = this.timeline
            .to($logoAside, 2, {transform:"translateY(0)", opacity: 1, ease: Power4.easeOut});
        
        var chunk1scene5 = new ScrollMagic.Scene({triggerElement: "#trigger1", triggerHook: "onLeave", duration: 200})
            .setTween(chunk1scene5Tween)
            .addTo(this.controller);
    
    
        // _____________________________________________________________________
        
    }

    // _________________________________________________________________________
    
    /**
     * Se la finestra riceve uno scroll annulla l'automatismo.
     * Altrimenti se entro 2 secondi non ci sono scroll, scrolla di 200px.
     * @returns {undefined}
     */
    task3() {
        // default options
        const options = {
          // duration of the scroll per 1000px, default 500
          speed: 5000,

          // minimum duration of the scroll
          minDuration: 4000,

          easing: (t) => { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t }, // easeInOutQuad

          // maximum duration of the scroll
          maxDuration: 5000,

          // DOM element to scroll, default window
          // Pass a reference to a DOM object
          // Example: document.querySelector('#element-to-scroll'),
          element: window,

          // should animated scroll be canceled on user scroll/keypress
          // if set to "false" user input will be disabled until animated scroll is complete
          cancelOnUserAction: true
        };

        const desiredOffset = 1000;

        var autoscrolltimer = setTimeout(() => {
            animateScrollTo(desiredOffset, options);
        },4000);

        window.addEventListener('scroll', this.debounce(() => {
            clearTimeout(autoscrolltimer);
        },100)); // 1s di debounce
    }

    // _________________________________________________________________________

    /**
     * Rende visibile step 1 (solo testo intro con una immagine di sfondo) o 2 (glide slider, loghi, substeps, ecc) a seconda della posizione
     * Ogni N ms verifica lo step corrente.
     * 
     * @returns {undefined}
     */
    task4() {
        var $glide__track = this.$module.querySelector('.glide__track');

        // se è 1
        if(this.step == 1) {
            $glide__track.classList.remove('active');
        }

        // se è 2 o 3
        if(this.step == 2 || this.step == 3) {

            if(this.$module.getAttribute('data-updated') == 'false') {
                this.carousel_update();
            }

            $glide__track.classList.add('active');

            // prende il testo della N slide e lo carica nella slide base
            var $current_step2 = this.$module.querySelectorAll('.step2.hidden-step')[this.carousel.index]; // ottiene il current step basato sull'indice corrente del carosello
            var $current_substeps = $current_step2.querySelectorAll('.substep');
            var $step2 = this.$module.querySelector('.step2');
            var $substeps = $step2.querySelectorAll('.substep');

            // passa i nodi .substep dal current step2.hidden-step a step2.active
            $current_substeps.forEach(($substep,i) => {
                if($substeps[i].innerHTML != $current_substeps[i].innerHTML) {
                    $substeps[i].innerHTML = $current_substeps[i].innerHTML; // passa i dati
                }
            });
        }

        // new iteration
        setTimeout(() => { this.task4(); },400);
    }

    // _________________________________________________________________________

    /**
     * STEP COUNTER
     * Ogni N ms verifica lo step corrente.
     * 
     * @returns {undefined}
     */
    task5() {
        var that = this;

        var $step_counter = this.$module.querySelector('.step-counter');
        var $items = $step_counter.querySelectorAll('.item');
        
        // event click, va alla slide corrispondente
        $items.forEach(($item,i) => {
            $item.addEventListener('click',() => {
                that.carousel.go('=' + i);
            });
        });

        // se è 1
        if(this.step == 1) {
            $step_counter.classList.remove('active');
        }

        // se è 2 o 3
        if(this.step == 2 || this.step == 3) {
            $step_counter.classList.add('active');
        }

        $items.forEach(($item,i) => {
            var current_item_key = $item.getAttribute('data-key');
            
            // se la chiave coincide lo segna come attivo
            if(parseInt(that.carousel.index) === parseInt(current_item_key)) {
                $item.classList.add('active');
            } else {
                $item.classList.remove('active');
            }
        });

        // new iteration
        setTimeout(() => { this.task5(); },400);
    }

    // _________________________________________________________________________


    /**
     * Aggiorna il carousel
     * @returns {undefined}
     */
    carousel_update() {
        this.$module.setAttribute('data-updated',true);

        this.carousel.update({
            type: 'carousel',
            gap: 0,
            autoplay: 3000,
            animationDuration: 1000,
        });

        console.log('invocato update');
    }

    /**
     * Inizializza il carousel
     * @returns {undefined}
     */
    carousel_init() {
        var that = this;
        
        this.carousel = new Glide('.glide').mount({ Controls, Breakpoints, Autoplay });
        
        // init
        this.carousel.update({
            type: 'carousel',
            gap: 0,
            autoplay: false,
            animationDuration: 1000,
        });
        
        // on window resize -> debounce -> carousel_update
        window.addEventListener('resize', this.debounce(() => {
            that.carousel_update();
        },1000)); // 1s di debounce
    }

    // _________________________________________________________________________


   
}

// export
export default new Module();